export function getLmBaseURL() {
  return (process.env.LM_BASE_URL || '').replace(/\/+$/, '')
}

/** 微信开放平台授权回调页（前端路由，与后台 redirect_uri 一致） */
export const WX_FRONT_CALLBACK_PATH = '/user/wx/callback'

/** iframe 回调页 postMessage 给登录页的消息类型 */
export const WX_LOGIN_MESSAGE_TYPE = 'aigc_wx_login'

export function pickLmDisplayName(data) {
  const d = data && typeof data === 'object' ? data : {}
  const candidates = [
    d.baicloud_name,
    d.name,
    d.nickname,
    d.nick_name,
    d.user_name,
    d.userName,
    d.real_name,
    d.realName,
    d.auth_name,
    d.weixin_nickname,
    d.mobile,
    d.phone,
  ]
  for (let i = 0; i < candidates.length; i += 1) {
    const s = candidates[i] != null ? String(candidates[i]).trim() : ''
    if (s && s.toLowerCase() !== 'undefined' && s.toLowerCase() !== 'null') return s
  }
  return ''
}

export function pickApiErrorMsg(payload) {
  const p = payload && typeof payload === 'object' ? payload : {}
  const nested = p.data && typeof p.data === 'object' ? p.data : {}
  const candidates = [
    p.msg,
    p.error_msg,
    p.message,
    nested.msg,
    nested.error_msg,
    nested.message,
  ]
  for (let i = 0; i < candidates.length; i += 1) {
    const s = candidates[i] != null ? String(candidates[i]).trim() : ''
    if (s) return s
  }
  return ''
}

export function pickWxLoginUrl(data) {
  const d = data && typeof data === 'object' ? data : {}
  const candidates = [d.url, d.login_url, d.wx_url, d.qrcode_url]
  for (let i = 0; i < candidates.length; i += 1) {
    const s = candidates[i] != null ? String(candidates[i]).trim() : ''
    if (s) return s
  }
  return ''
}

export function pickOpenId(data) {
  const d = data && typeof data === 'object' ? data : {}
  return String(d.openid || d.open_id || '').trim()
}

export function isWxBound(data) {
  const d = data && typeof data === 'object' ? data : {}
  if (d.front_userBind === 1 || d.front_userBind === true) return true
  if (d.token || d.front_token || d.baicloud_token) return true
  return false
}

export function applyLoginSession(store, data, mobileFallback) {
  const raw = data && typeof data === 'object' ? data : {}
  const merged = { ...raw }
  const fb = mobileFallback != null ? String(mobileFallback).trim() : ''
  if (fb && !merged.mobile) merged.mobile = fb
  const displayName = pickLmDisplayName(merged)

  const exp = new Date()
  exp.setTime(exp.getTime() + 1000 * (raw.expire_time || 30 * 24 * 3600) + 8 * 3600 * 1000)
  const isProd = window.location.host.indexOf('ibaicloud.com') !== -1
  const domainPart = isProd && raw.domain ? `;Domain=${raw.domain}` : ''
  const opts = `expires=${exp.toGMTString()};Path=/${domainPart}`
  const token = raw.token || raw.front_token || raw.baicloud_token || ''
  const userId = raw.baicloud_user_id != null && String(raw.baicloud_user_id).trim() !== ''
    ? raw.baicloud_user_id
    : raw.front_userId != null && String(raw.front_userId).trim() !== ''
      ? raw.front_userId
      : raw.uid != null
        ? raw.uid
        : ''

  document.cookie = `front_token=${token};${opts}`
  document.cookie = `front_userId=${userId};${opts}`
  document.cookie = `front_userName=${encodeURIComponent(displayName)};${opts}`

  if (store) {
    try {
      const u = store.state.user
      store.commit('updateUser', {
        ...u,
        user_id: String(userId !== '' ? userId : u.user_id || ''),
        user_name: displayName || u.user_name || '',
        mobile: String(merged.mobile != null ? merged.mobile : u.mobile || ''),
        loginStatus: true,
      })
    } catch (e) {
      /* ignore */
    }
  }
}

export function resolveLoginRedirect(route) {
  const raw = route && route.query ? route.query.redirect : ''
  let redirect = raw != null ? String(raw).trim() : ''
  if (!redirect) return ''
  try {
    redirect = decodeURIComponent(redirect)
  } catch (e) { /* ignore */ }
  if (!redirect.startsWith('/')) return ''
  if (redirect.startsWith('/login')) return ''
  return redirect
}

let wxLoginCompleting = false

/** 用微信 code 完成登录（绑定手机号时跳转 bind 页） */
export async function completeWxLogin(ctx, code, state) {
  const trimmedCode = code != null ? String(code).trim() : ''
  const trimmedState = state != null ? String(state).trim() : ''
  if (!trimmedCode || wxLoginCompleting) return false
  wxLoginCompleting = true
  const axios = ctx && ctx.axios
  const store = ctx && ctx.store
  const router = ctx && ctx.router
  const route = ctx && ctx.route
  if (!axios || !router) {
    wxLoginCompleting = false
    return false
  }
  try {
    const resp = await axios({
      baseURL: getLmBaseURL(),
      url: '/user/wx/callback/',
      method: 'get',
      params: { code: trimmedCode, state: trimmedState },
    })
    const body = resp.data || {}
    const data = body.data && typeof body.data === 'object' ? body.data : body
    if (body.status !== 1) {
      throw new Error(pickApiErrorMsg(body) || '微信登录失败')
    }
    if (data.error_msg) {
      throw new Error(String(data.error_msg))
    }
    if (isWxBound(data)) {
      applyLoginSession(store, data, data.mobile)
      await navigateAfterLogin(router, route)
      return true
    }
    const openid = pickOpenId(data)
    if (!openid) {
      throw new Error('未获取到微信 openid')
    }
    await router.replace({ name: 'wx_bind', query: { openid } })
    return true
  } catch (e) {
    const msg = (e.response && pickApiErrorMsg(e.response.data)) || e.message || '微信登录失败'
    if (ctx && typeof ctx.onError === 'function') {
      ctx.onError(msg)
    }
    throw e
  } finally {
    wxLoginCompleting = false
  }
}

export async function navigateAfterLogin(router, route) {
  const redirect = resolveLoginRedirect(route)
  const fallback = { name: 'lm_image_create' }
  try {
    if (redirect) {
      await router.replace(redirect)
    } else {
      await router.replace(fallback)
    }
  } catch (e) {
    try {
      await router.replace(fallback)
    } catch (err) {
      window.location.hash = '#/aigc/create'
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/loginAuth.js